document.addEventListener('DOMContentLoaded', () => {
    const chatPopup = document.getElementById('chat-popup');
    const chatToggleBtn = document.getElementById('chat-toggle-btn');
    const closeChatPopupBtn = document.getElementById('close-chat-popup');
    const backToChatListBtn = document.getElementById('back-to-chat-list');

    const chatPopupTitle = document.getElementById('chat-popup-title');

    const chatListView = document.getElementById('chat-list-view');
    const chatListContainer = document.getElementById('chat-list-container');
    const chatListLoader = document.getElementById('chat-list-loader');

    const chatMessagesView = document.getElementById('chat-messages-view');
    const chatMessagesContainer = document.getElementById('chat-messages-container');
    const chatMessagesLoader = document.getElementById('chat-messages-loader');

    const messageForm = document.getElementById('chat-message-form');
    const messageInput = document.getElementById('chat-message-input');

    if (!chatPopup) return;

    let chatListPage = 1;
    let chatListHasMore = true;
    let isLoadingChatList = false;

    let messagePage = 1;
    let messageHasMore = true;
    let isLoadingMessages = false;
    let currentOrder = null;

    const toggleChatPopup = () => {
        chatPopup.classList.toggle('translate-x-full');
        if (!chatPopup.classList.contains('translate-x-full') && chatListContainer.childElementCount === 0) {
            loadChatList(true);
        }
    };

    const showListView = () => {
        chatMessagesView.classList.add('hidden');
        chatListView.classList.remove('hidden');
        backToChatListBtn.classList.add('hidden');
        chatPopupTitle.innerHTML = 'Chats';
        currentOrder = null;
    };

    const showMessagesView = (order) => {
        chatListView.classList.add('hidden');
        chatMessagesView.classList.remove('hidden');
        backToChatListBtn.classList.remove('hidden');

        // Create clickable order link in title
        chatPopupTitle.innerHTML = `
            <div class="flex items-center gap-2">
                <span>Order:</span>
                <a href="/orders/${order.id}"
                   target="_blank"
                   class="text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 underline font-medium"
                   title="Open order in new tab">
                    ${order.topic}
                    <svg class="inline w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                    </svg>
                </a>
            </div>
        `;

        currentOrder = order;
        chatMessagesContainer.innerHTML = '';
        messagePage = 1;
        messageHasMore = true;
        loadMessages(true);
    };

    chatToggleBtn.addEventListener('click', toggleChatPopup);
    closeChatPopupBtn.addEventListener('click', toggleChatPopup);
    backToChatListBtn.addEventListener('click', showListView);

    async function loadChatList(fresh = false) {
        if (isLoadingChatList || !chatListHasMore) return;

        isLoadingChatList = true;
        chatListLoader.style.display = 'block';
        if(fresh) {
            chatListPage = 1;
            chatListContainer.innerHTML = '';
        }

        try {
            const response = await fetch(`/chats?page=${chatListPage}`);
            const result = await response.json();

            console.log('Chat list result:', result); // Debug log

            result.data.forEach(order => {
                console.log('Processing order:', order); // Debug log
                const item = document.createElement('div');
                item.className = 'p-4 border-b border-gray-200 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800';

                const otherUser = getOtherUser(order);
                const lastMessage = order.last_chat_message || null;

                let lastMessagePreview = 'No messages yet.';
                if (lastMessage && typeof lastMessage.content === 'string') {
                    const isCurrentUserMessage = lastMessage.user && window.currentUser && lastMessage.user.id === window.currentUser.id;
                    const sender = isCurrentUserMessage ? 'You: ' : '';
                    lastMessagePreview = `${sender}${lastMessage.content}`;
                }

                let statusColor = 'bg-gray-400';
                if(order.status === 'completed') statusColor = 'bg-green-500';
                if(order.status === 'in_progress') statusColor = 'bg-blue-500';

                const timeDisplay = lastMessage && lastMessage.created_at
                    ? new Date(lastMessage.created_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
                    : '';

                item.innerHTML = `
                    <div class="flex items-center justify-between">
                        <p class="font-bold truncate">${order.topic || 'Untitled Order'}</p>
                        <p class="text-xs text-gray-500">${timeDisplay}</p>
                    </div>
                    <div class="flex items-center mt-1">
                        <span class="w-2 h-2 mr-2 rounded-full ${statusColor}"></span>
                        <p class="text-sm text-gray-500 truncate">${otherUser ? otherUser.name : 'N/A'}</p>
                    </div>
                    <p class="text-sm text-gray-600 dark:text-gray-400 mt-1 truncate">${lastMessagePreview}</p>
                `;
                item.addEventListener('click', () => showMessagesView(order));
                chatListContainer.appendChild(item);
            });

            if (result.next_page_url) {
                chatListPage++;
                chatListHasMore = true;
            } else {
                chatListHasMore = false;
            }

        } catch (error) {
            console.error('Failed to load chat list:', error);
            chatListContainer.innerHTML = '<p class="p-4 text-red-500">Failed to load chats.</p>';
        } finally {
            isLoadingChatList = false;
            chatListLoader.style.display = 'none';
        }
    }

    chatListView.addEventListener('scroll', () => {
        if (chatListView.scrollTop + chatListView.clientHeight >= chatListView.scrollHeight - 5) {
            loadChatList();
        }
    });

    async function loadMessages(fresh = false) {
        if (isLoadingMessages || !messageHasMore || !currentOrder) return;

        isLoadingMessages = true;
        chatMessagesLoader.style.display = 'block';
        if(fresh) {
            messagePage = 1;
            chatMessagesContainer.innerHTML = '';
        }

        try {
            const response = await fetch(`/orders/${currentOrder.id}/chat?page=${messagePage}`);
            const result = await response.json();

            const isScrolledToBottom = chatMessagesContainer.scrollHeight - chatMessagesContainer.clientHeight <= chatMessagesContainer.scrollTop + 1;

            result.data.reverse().forEach(message => {
                console.log('Processing message:', message); // Debug log
                const item = document.createElement('div');
                const isCurrentUser = message.user && window.currentUser && message.user.id === window.currentUser.id;
                const userName = (message.user && message.user.name) ? message.user.name : 'Unknown User';
                const messageText = message.content || '[No message content]';
                const messageTime = message.created_at ? new Date(message.created_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) : '';

                item.className = `flex items-start gap-2.5 ${isCurrentUser ? 'justify-end' : ''}`;
                item.innerHTML = `
                    <div class="flex flex-col w-full max-w-[320px] leading-1.5 p-4 border-gray-200 ${isCurrentUser ? 'bg-indigo-100 dark:bg-indigo-900' : 'bg-gray-100 dark:bg-gray-700'} rounded-e-xl rounded-es-xl">
                        <div class="flex items-center space-x-2 rtl:space-x-reverse ${isCurrentUser ? 'justify-end' : ''}">
                            <span class="text-sm font-semibold text-gray-900 dark:text-white">${userName}</span>
                            <span class="text-sm font-normal text-gray-500 dark:text-gray-400">${messageTime}</span>
                        </div>
                        <p class="text-sm font-normal py-2.5 text-gray-900 dark:text-white">${messageText}</p>
                    </div>
                `;
                chatMessagesContainer.prepend(item);
            });

            if (result.next_page_url) {
                messagePage++;
                messageHasMore = true;
            } else {
                messageHasMore = false;
            }

            if(isScrolledToBottom || fresh) {
                chatMessagesContainer.scrollTop = chatMessagesContainer.scrollHeight;
            }

        } catch (error) {
            console.error('Failed to load messages:', error);
        } finally {
            isLoadingMessages = false;
            chatMessagesLoader.style.display = 'none';
        }
    }

    chatMessagesContainer.addEventListener('scroll', () => {
        if (chatMessagesContainer.scrollTop === 0) {
            loadMessages();
        }
    });

    messageForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const message = messageInput.value.trim();
        if (!message || !currentOrder) return;

        messageInput.disabled = true;

        try {
            const response = await fetch(`/orders/${currentOrder.id}/chat`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ content: message })
            });

            if(response.ok) {
                messageInput.value = '';
                // The message will be received via WebSocket, so we don't need to add it manually
                // For now, let's add it manually for responsiveness
                 const newMessage = {
                    user: window.currentUser,
                    content: message,
                    created_at: new Date().toISOString()
                };
                appendMessage(newMessage);

            } else {
                throw new Error('Failed to send message');
            }

        } catch (error) {
            console.error(error);
            alert('Failed to send message.');
        } finally {
            messageInput.disabled = false;
            messageInput.focus();
        }
    });

    function appendMessage(message) {
        const item = document.createElement('div');
        const isCurrentUser = message.user && window.currentUser && message.user.id === window.currentUser.id;
        const userName = (message.user && message.user.name) ? message.user.name : 'Unknown User';
        const messageText = message.content || '[No message content]';
        const messageTime = message.created_at ? new Date(message.created_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) : '';

        item.className = `flex items-start gap-2.5 ${isCurrentUser ? 'justify-end' : ''}`;
        item.innerHTML = `
            <div class="flex flex-col w-full max-w-[320px] leading-1.5 p-4 border-gray-200 ${isCurrentUser ? 'bg-indigo-100 dark:bg-indigo-900' : 'bg-gray-100 dark:bg-gray-700'} rounded-e-xl rounded-es-xl">
                <div class="flex items-center space-x-2 rtl:space-x-reverse ${isCurrentUser ? 'justify-end' : ''}">
                    <span class="text-sm font-semibold text-gray-900 dark:text-white">${userName}</span>
                    <span class="text-sm font-normal text-gray-500 dark:text-gray-400">${messageTime}</span>
                </div>
                <p class="text-sm font-normal py-2.5 text-gray-900 dark:text-white">${messageText}</p>
            </div>
        `;
        chatMessagesContainer.appendChild(item);
        chatMessagesContainer.scrollTop = chatMessagesContainer.scrollHeight;
    }


    function getOtherUser(order) {
        if (!window.currentUser) return null;

        if (window.currentUser.role === 'client' && order.manager) {
            return order.manager;
        }
        if (window.currentUser.role === 'writer' && order.user) {
            return order.user;
        }
        if (window.currentUser.role === 'admin') {
            // In a group chat, this logic could be more complex.
            // For now, let's show client or writer.
            return order.user || order.manager;
        }
        return null;
    }

    // Echo listener
    if (window.Echo) {
       window.Echo.private(`chat.${window.currentUser.id}`)
        .listen('NewChatMessage', (e) => {
            if (currentOrder && e.message.order_id === currentOrder.id) {
                // If we are viewing the chat, append the message
                if(e.message.user_id !== window.currentUser.id) {
                    appendMessage(e.message);
                }
            }
            // You might want to update the chat list as well, to show new message preview
            // and reorder chats. For simplicity, this is omitted here.
        });
    }

});
